import { Fragment, ReactNode } from 'react';

import { Breadcrumbs, Button, Title, TuneIcon, type TypeBreadcrumbsItem } from '@thefarmersfront/kitchen';

import styles from './PageTitle.module.scss';

type FilterProps =
  | {
      hasFilter?: true;
      handleFilterToggle: () => void;
    }
  | {
      hasFilter: false;
      handleFilterToggle?: never;
    };

type PageTitleProps = {
  title: string;
  titleExtra?: ReactNode;
  breadcrumbs: TypeBreadcrumbsItem[];
  description?: ReactNode | ReactNode[];
} & FilterProps;

const PageTitle = ({ title, titleExtra, breadcrumbs, description, handleFilterToggle }: PageTitleProps) => {
  return (
    <div className={styles['page-title-container']}>
      <div className={styles['title-container']}>
        <div className={styles['title-left-section']}>
          <Title size="accessibility1" weight="bold">
            {title}
          </Title>
          {titleExtra}
          {handleFilterToggle && (
            <Button
              variant="outlined"
              color="tertiary"
              size="tiny"
              leftIcon={<TuneIcon size={16} />}
              onClick={handleFilterToggle}
            >
              필터
            </Button>
          )}
        </div>
        <Breadcrumbs items={breadcrumbs} />
      </div>
      {description && (
        <div className={styles['description-wrapper']}>
          {Array.isArray(description)
            ? description.map((description, index) => <Fragment key={index}>{description}</Fragment>)
            : description}
        </div>
      )}
    </div>
  );
};

export default PageTitle;
